module.exports = {
  DEFAULT_PROJECTION: 'globe',
  DEFAULT_STYLE: 'Standard',
  DEFAULT_DARK_FEATURE_COLOR: '#555',
  DEFAULT_LIGHT_FEATURE_COLOR: '#e8e8e8',
  DEFAULT_SATELLITE_FEATURE_COLOR: '#00f900',
  DEFAULT_3D_BUILDINGS: true
};
